import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import { css } from 'css-literal-loader/styled';

const styles = require('./CompatibilityInfoLink-styles.module.scss');

const propTypes = {};

class CompatibilityInfoLink extends React.Component {
  handleScrollToRef = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const node = ReactDOM.findDOMNode(
      this.props.compatibilitySegmentRef.current,
    );
    window.scrollTo({ left: 0, top: node.offsetTop, behavior: 'smooth' });
  };

  render() {
    return (
      <button
        type="button"
        onClick={this.handleScrollToRef}
        className={styles.button}
      >
        <FormattedMessage
          defaultMessage="See compatibility"
          id="compatibilityInfo.button"
        />
      </button>
    );
  }
}

CompatibilityInfoLink.propTypes = propTypes;

export default CompatibilityInfoLink;
